import React from 'react'

import { ScrollMenu } from 'react-horizontal-scrolling-menu'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

import { LeftArrow, RightArrow } from './arrows'
import { Card } from './card'
import { articles } from './data'

import './globalStyles.scss'

// NOTE: embrace power of CSS flexbox!
// import "./arrowsOnBottomOrTop.css";
import './hideScrollbar.scss'
import './firstItemMargin.css'

const getId = (index: number) => `${index}`

const isNotMobile = window.innerWidth >= 712

const getItems = () =>
  articles.map((a, ind) => ({
    id: getId(ind),
    abo: a.abo,
    overline: a.overline,
    title: a.title,
    lead: a.lead,
    icon: a.icon,
    articleId: a.articleId,
    className: a.class
  }))

export function ArticleTeaserCarousel(props) {
  const [items] = React.useState(getItems)
  const hostdomain = props.forceDomain || parseHostname().publicationName

  // remove item with articleId where you come from
  let newItems = items.filter(
    item => item.articleId !== props.articleIdToRemove
  )
  if (
    hostdomain !== 'tagesanzeiger' &&
    hostdomain !== 'landbote' &&
    hostdomain !== 'zsz' &&
    hostdomain !== 'zuonline'
  ) {
    newItems = newItems.filter(item => item.articleId !== '208920009412')
  }

  return (
    <>
      <div className={isNotMobile ? 'ui container' : ''} id='dashboardCarousel'>
        <div className='cardContainer'>
          <ScrollMenu
            LeftArrow={LeftArrow}
            RightArrow={RightArrow}
            options={{
              ratio: 0.9,
              rootMargin: '5px',
              threshold: [0.01, 0.05, 0.5, 0.75, 0.95, 1]
            }}
          >
            {newItems.map(
              ({
                id,
                abo,
                overline,
                title,
                lead,
                icon,
                articleId,
                className
              }) => (
                <Card
                  abo={abo}
                  overline={overline}
                  title={title}
                  itemId={id} // NOTE: itemId is required for track items
                  key={id}
                  icon={icon}
                  lead={lead}
                  url={`//${hostdomain}.ch/${articleId}`}
                  className={className}
                />
              )
            )}
          </ScrollMenu>
          {!isNotMobile && <div className='gradientLeft' />}
          <div className='gradientRight' />
        </div>
      </div>
    </>
  )
}
